/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber12Small = createReactComponent("outline", "number-12-small", "IconNumber12Small", [["path", { "d": "M7 10l2 -2v8", "key": "svg-0" }], ["path", { "d": "M13 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

export { IconNumber12Small as default };
//# sourceMappingURL=IconNumber12Small.mjs.map
